/**
 * itapplicationaction.js
 **/

import {
	GET_ALL_IT_APPLICATIONS,
	GET_IT_APPLICATION,
	UPDATE_ITAPPLICATION,
	CREATE_ITAPPLICATION_SO,
	DELETE_ITAPPLICATION,
	GET_ITAPPSO_BY_ID,
	CREATE_ITAPPLICATION_ITPROCESS_RELATIONSHIP,
	DELETE_ITAPPLICATION_ITPROCESS_RELATION
} from '../actiontypes';
import {GetAllItsoApplicationsUrl, createApiAction, GetByIdITAppSoUrl} from '../apiUrls';
import {API_RESOURCES, createApiCreateAction, createApiDeleteAction, createApiUpdateAction} from '../../util/api';

/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request for all of the IT Applications in the specified Engagement.
 * @param {Number} engagementId The Engagement ID.
 * @param {Object} args. Extra arguments.
 * @param {Object} filters The filters to be applied.
 * @returns {Object} An action object to be dispatched and treated by the api-middleware.
 */
export const getAllItApplications = (engagementId, args, filters) =>
	createApiAction(
		GET_ALL_IT_APPLICATIONS,
		GetAllItsoApplicationsUrl(engagementId, filters),
		'GET',
		undefined,
		undefined,
		args
	);

export const getITApplication = (url) => {
	return {
		type: GET_IT_APPLICATION,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const getItApplications = (engagementId, filters) =>
	createApiAction(GET_IT_APPLICATION, GetAllItsoApplicationsUrl(engagementId, filters), 'GET');

export const getITAppSoById = (engagementId, entityUId, filters) =>
	createApiAction(GET_ITAPPSO_BY_ID, GetByIdITAppSoUrl(engagementId, entityUId, filters), 'GET');

/**
 * Returns an action to be dispatched for updating the specified IT application.
 * @param {number} engagementId The engagement's Id.
 * @param {number} itApplicationId The IT application's Id.
 * @param {data} data The payload data
 * @returns {object} The action to be dispatched.
 */
export const updateItApplication = (engagementId, itApplicationId, data) => {
	return createApiUpdateAction(
		UPDATE_ITAPPLICATION,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITAPPLICATIONS]: itApplicationId
		},
		data
	);
};

/**
 * Returns an action to be dispatched for creating IT application SO.
 * @param {number} engagementId The engagement's Id.
 * @param {data} data The payload data
 * @returns {object} The action to be dispatched.
 */
export const createItApplicationSO = (engagementId, data) => {
	return createApiCreateAction(
		CREATE_ITAPPLICATION_SO,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITAPPLICATIONS]: undefined
		},
		data
	);
};

/**
 * Returns an action to be dispatched for createItApplicationItProcessRelationship.
 * @param {number} engagementId The engagement's Id.
 * @param {number} itApplicationId The IT application's Id.
 * @param {itProcessId} itProcessId The ITProcess Id.
 * @returns {object} The action to be dispatched.
 */
export const createItApplicationItProcessRelationship = (engagementId, itApplicationId, itProcessId) => {
	return createApiCreateAction(
		CREATE_ITAPPLICATION_ITPROCESS_RELATIONSHIP,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITAPPLICATIONS]: itApplicationId,
			[API_RESOURCES.ITPROCESSES]: undefined
		},
		{itProcessId}
	);
};

/**
 * Returns an action to be dispatched for deleting the specified IT application.
 * @param {number} engagementId The engagement's Id.
 * @param {number} bodyId The document's Id.
 * @param {number} itApplicationId The IT application's Id.
 * @returns {object} The action to be dispatched.
 */
export const deleteItApplication = (engagementId, bodyId, itApplicationId) => {
	return createApiDeleteAction(
		DELETE_ITAPPLICATION,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITAPPLICATIONS]: itApplicationId
		},
		{
			bodyId,
			itApplicationId
		}
	);
};

export const deleteItappItprocessRelation = (engagementId, entity, targetEntity, targetId, itApplicationId) => {
	return createApiDeleteAction(
		DELETE_ITAPPLICATION_ITPROCESS_RELATION,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITAPPLICATIONS]: itApplicationId,
			[API_RESOURCES.ITPROCESSES]: targetId
		},
		{
			target: {
				entity: targetEntity,
				id: targetId
			},
			entity,
			itApplicationId
		}
	);
};
